import { MenuItem, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ThemeTokens } from '@acp/core-ui';
import { useNavLink } from '@acp/feature/auth';

export type MobileNavigationItemProps = {
    to?: string;
    label: string;
    isExternal?: boolean;
    onClick?: () => void;
};

export function MobileNavigationMenuItem({
    to,
    label,
    isExternal = false,
    onClick,
}: MobileNavigationItemProps) {
    const href = useNavLink({ to, isExternal });

    return (
        <MenuItem
            as={onClick === undefined ? Link : undefined}
            to={href ?? ''}
            onClick={onClick}
            p={0}
        >
            <Text
                px={ThemeTokens.Defaults.px}
                py={ThemeTokens.Defaults.py}
                pl={8}
                borderBottomWidth={1}
                borderBottomColor="muted.50"
                w="full"
            >
                {label}
            </Text>
        </MenuItem>
    );
}
